export default __webpack_public_path__ + "static/media/MS.4386c997.svg";